import { emeraldGreen, terracotta } from "Constants/ColourConstants";

export const styles = {
  mainStack: {
    width: "100%",
    height: "fit-content",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingY: 2,
    [`@media (max-width: 450px)`]: {
      paddingY: 1,
      alignItems: "flex-end",
    },
  },
  headerStack: {
    width: "100%",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: { sm: "center" },
    minWidth: "200px",
  },
  backAndTitleStack: (hasPatient) => ({
    width: hasPatient ? "100%" : "max-content",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 1,
    [`@media (max-width: 450px)`]: {
      width: "fit-content",
      flexDirection: hasPatient ? "column-reverse" : "row",
      alignItems: hasPatient ? "flex-start" : "center",
      paddingBottom: "1px",
    },
  }),
  patientInfoStack: {
    width: "50%",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 1,
    color: emeraldGreen,
    [`@media (max-width: 450x)`]: {
      width: "fit-content",
      maxWidth: "40%",
    },
  },
  patientInfo: {
    width: "fit-content",
    textAlign: "left",
    fontWeight: "bold",
    color: emeraldGreen,
    lineHeight: "15px",
    fontSize: {
      xs: "12px",
      sm: "14px",
      md: "18px",
    },
  },
  header: {
    color: emeraldGreen,
    fontSize: {
      xs: "14px",
      sm: "18px",
      md: "22px",
    },
    fontWeight: "bold",
    lineHeight: "26px",
    textAlign: "left",
    textTransform: "uppercase",
  },
  logo: {
    backgroundColor: "white",
    borderRadius: "50%",
    border: `2px solid ${terracotta}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: {
      xs: "35px",
      sm: "40px",
      md: "50px",
    },
    minHeight: {
      xs: "35px",
      sm: "40px",
      md: "50px",
    },
  },
  initials: {
    color: terracotta,
    textTransform: "uppercase",
    fontWeight: "medium",
    fontSize: {
      xs: "18px",
      sm: "20px",
      md: "24px",
    },
  },
};
